// extracted by mini-css-extract-plugin
module.exports = {"summary":"_1WpNRH","title":"_3kIeRl","synopsis":"x-f4Zx"};